import { useLocation, useNavigate } from '@remix-run/react'
import { useEffect } from 'react'

export const useClearParams = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const clear = () => {
    navigate(location.pathname)
  }

  useEffect(() => {
    return () => {
      clear()
    }
  }, [])

  return {
    clear,
  }
}
